export default __webpack_public_path__ + "static/Plots0011-1f469773b82e6ff5a00f1911d301845d.jpg";